"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalService = void 0;
const __1 = require("..");
class GlobalService {
    constructor(globalStorage, contractsMap) {
        this.globalStorage = globalStorage;
        this.contractsMap = contractsMap;
    }
    publishGlobals(chainId, upcomingGlobals) {
        return __awaiter(this, void 0, void 0, function* () {
            const updateResult = yield this.globalStorage.updateGlobals(chainId, upcomingGlobals);
            const deleteResult = yield this.globalStorage.deleteGlobalsBefore(chainId, upcomingGlobals.current_epoch - 1);
            return updateResult && deleteResult;
        });
    }
    publishLockTrigger(chainId, process, locked) {
        return __awaiter(this, void 0, void 0, function* () {
            let attributes = {};
            switch (process) {
                case 'SCORES':
                    attributes = { is_publishing_scores_locked: locked };
                    break;
                case 'PASSPORTSTATS':
                    attributes = { is_publishing_stats_locked: locked };
                    break;
            }
            return this.globalStorage.updateGlobals(chainId, attributes);
        });
    }
    fetchGlobals(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.globalStorage.readGlobals(chainId);
        });
    }
    fetchUpcomingGlobals(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const contractProperties = (0, __1.getCrossChainContracts)(chainId, this.contractsMap.passportScores);
            const [onChainInfo, currentGlobals] = yield Promise.all([
                (0, __1.getSapphirePassportScoresInfo)(contractProperties),
                this.fetchGlobals(chainId),
            ]);
            return new __1.Global(onChainInfo.currentEpoch, onChainInfo.currentEpochDelaySecs, onChainInfo.currentMerkleRoot, onChainInfo.upcomingMerkleRoot, 
            // Ensure all booleans exist
            !!currentGlobals.is_publishing_scores_locked, !!currentGlobals.is_publishing_stats_locked, !!onChainInfo.areAllSameEpoch, !!onChainInfo.areAllAcceptingRoot, !!onChainInfo.areAllNotPaused, !!onChainInfo.areAllSameUpcomingRoot);
        });
    }
}
exports.GlobalService = GlobalService;
//# sourceMappingURL=GlobalService.js.map